import { render, staticRenderFns } from "./aiCard.vue?vue&type=template&id=67efd8ac&scoped=true"
import script from "./aiCard.vue?vue&type=script&lang=js"
export * from "./aiCard.vue?vue&type=script&lang=js"
import style0 from "./aiCard.vue?vue&type=style&index=0&id=67efd8ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67efd8ac",
  null
  
)

export default component.exports